import { render } from "./TopNavBar.vue?vue&type=template&id=baa247ae&scoped=true"
import script from "./TopNavBar.vue?vue&type=script&lang=js"
export * from "./TopNavBar.vue?vue&type=script&lang=js"

import "./TopNavBar.vue?vue&type=style&index=0&id=baa247ae&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2623155984/src/jamakkol-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baa247ae"]])

export default __exports__